import React from 'react'

import * as Styles from './styles'

const QuizContainerBorder = () => {
    return (
        <>
            <Styles.BorderLevelOne />
            <Styles.BorderLevelTwo />
        </>
    )
}

export default QuizContainerBorder
